module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list', {
    attrs: {
      "dense": "",
      "subheader": ""
    }
  }, [(_vm.title) ? _c('v-subheader', [(_vm.loading) ? _c('v-progress-circular', {
    staticClass: "mr-2",
    attrs: {
      "indeterminate": "",
      "size": 18,
      "width": 2,
      "color": "amber"
    }
  }) : _vm._e(), _vm._v("\n    " + _vm._s(_vm.title) + "\n  ")], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.payments), function(payment) {
    return _c('v-list-tile', {
      key: payment.id,
      attrs: {
        "disabled": _vm.deletingPayments.indexOf(payment.id) !== -1
      }
    }, [(_vm.withDelete) ? _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          _vm.deleteDialog = true;
          _vm.selectedPayment = payment
        }
      }
    }, [_c('v-icon', [_vm._v("delete")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n        " + _vm._s(_vm.dateformat(payment.transaction_date)) + "\n        "), (payment.method) ? [_vm._v(" via " + _vm._s(payment.method))] : _vm._e()], 2), _vm._v(" "), (payment.reference) ? _c('v-list-tile-sub-title', [_vm._v("\n        ref: " + _vm._s(payment.reference) + "\n      ")]) : _vm._e()], 1), _vm._v(" "), _c('v-list-tile-action', [_vm._v("\n      " + _vm._s(_vm.formatCurrency(payment.currency, payment.amount)) + "\n    ")])], 1)
  }), _vm._v(" "), (_vm.payments && _vm.payments.length === 0) ? _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n        No payments found for this appointment\n      ")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": 300
    },
    model: {
      value: (_vm.deleteDialog),
      callback: function($$v) {
        _vm.deleteDialog = $$v
      },
      expression: "deleteDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v("\n        Are you sure you want to delete this payment\n      ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.deleteDialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.deleteLoading,
      "color": "error"
    },
    on: {
      "click": _vm.deleteClicked
    }
  }, [_vm._v("Delete")])], 1)], 1)], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a68bc616","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/statement/PaymentList.vue
// module id = 1507
// module chunks = 9